import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { MaterialModule } from './material.module';
import { AuthenticationService } from './services/auth/authentication.service';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MaterialModule, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'epione-envira';
  isLoggedIn = false;

  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  async ngOnInit() {
    this.isLoggedIn = await this.authService.isLoggedIn();

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(async () => {
      this.isLoggedIn = await this.authService.isLoggedIn();
    });
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  async logout() {
    await this.authService.logOut();
    this.isLoggedIn = false;
    this.router.navigate(['/']);
  }
}
